import * as yup from 'yup'
import { ManualPlanningFormProfile } from './manual-reservation-form.profile'

export const schema: yup.ObjectSchema<ManualPlanningFormProfile> = yup.object({
  manualPosition: yup.string().required(),
})
